import React from 'react';
import {useI18n} from '../../i18n/useI18n';
import {GuardItem} from '../../pages/site/site.types';
import styles from './styles/RiskGuardSection.module.css';

interface RiskGuardSectionProps {
    items: GuardItem[];
}

const RiskGuardSection: React.FC<RiskGuardSectionProps> = ({items}) => {
    const {t} = useI18n();

    return (
        <div className={styles.grid}>
            {items.map(item => (
                <article className={`site-card ${styles.card}`} key={item.title}>
                    <span className="site-eyebrow">{t('site.risk.ruleLabel')}</span>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <div className={styles.list}>
                        {item.bullets.map(bullet => <span key={bullet}>{bullet}</span>)}
                    </div>
                </article>
            ))}
        </div>
    );
};

export default RiskGuardSection;
